import { useQuery } from "@tanstack/react-query";
import giftCategoriesClient from "../../../../api/giftCategories";

const useGiftOrderQuery = (orderName: string) => {
  return useQuery({
    queryKey: ["giftOrder", orderName],
    queryFn: () => giftCategoriesClient.getOrderGift(orderName),
    enabled: !!orderName,
  });
};

export default useGiftOrderQuery;
